import React, { Component } from 'react';
import MediumIcon from '../images/medium-128.png'
import GithubIcon from '../images/github-128.png'
import GmailIcon from '../images/gmail-128.png'
import LinkedinIcon from '../images/linkedin-128.png'
import FacebookIcon from '../images/facebook.png'
import {Link} from 'react-scroll'

export class NavbarOverlayComponent extends Component {
      
      render() {
            return (
                  <div className="navbar-overlay">
                        <div className="overlay-component">
                              <Link
                              activeClass="active"
                              to="profile"
                              spy={true}
                              smooth={true}
                              offset={-20}
                              duration= {500}
                              >
                              <div className="d-flex  justify-content-center nav-text">
                                    <h1 className="animated-nav-text">About Me</h1>
                              </div>
                              </Link>
                              <Link
                              activeClass="active"
                              to="experience"
                              spy={true}
                              smooth={true}
                              offset={0}
                              duration= {500}
                              >
                              <div className="d-flex  justify-content-center nav-text">
                                    <h1 className="animated-nav-text">Experience & Education</h1>
                              </div>
                              </Link>
                              <Link
                              activeClass="active"
                              to="people"
                              spy={true}
                              smooth={true}
                              offset={0}
                              duration= {500}
                              >
                              <div className="d-flex  justify-content-center nav-text">
                                    <h1 className="animated-nav-text">What People are saying on Fiverr !!</h1>
                              </div>
                              </Link>
                              <Link
                              activeClass="active"
                              to="project"
                              spy={true}
                              smooth={true}
                              offset={50}
                              duration= {500}
                              >
                              <div className="d-flex  justify-content-center nav-text">
                                    <h1 className="animated-nav-text">Projects</h1>
                              </div>
                              </Link>
                              <Link
                              activeClass="active"
                              to="contact"
                              spy={true}
                              smooth={true}
                              offset={0}
                              duration= {500}
                              >
                              <div className="d-flex  justify-content-center nav-text">
                                    <h1 className="animated-nav-text">Contact</h1>
                              </div>
                              </Link>
                              <div className="d-flex  justify-content-center mt-5">
                             <div className="ml-4 social-media-icons">
                                 <a href="https://www.linkedin.com/in/hardik-chugh-977a7b14b/" target="_blank" rel="noopener noreferrer" >  
                                   <img src={LinkedinIcon} alt="linkedin"  id="linkedin" />
                                 </a>
                             </div>
                             <div className="ml-4 social-media-icons">
                                  <a href="https://mail.google.com/mail/?view=cm&fs=1&su=Let's Connect Hardik&body=Hey Hardik!" target="_blank" rel="noopener noreferrer">
                                    <img src={GmailIcon} alt="gmail" id="gmail" />
                                  </a>
                             </div>
                             <div className="ml-4 social-media-icons">
                                  <a href="https://github.com/hardy1334/" target="_blank" rel="noopener noreferrer">
                                     <img src={GithubIcon} alt="github"  id="github" />
                                  </a>
                             </div>
                             <div className="ml-4 social-media-icons">
                                  <a href="https://medium.com/@hardychugh34" target="_blank" rel="noopener noreferrer">
                                     <img src={MediumIcon} alt="medium" id="medium" />
                                  </a>
                             </div>
                             <div className="ml-4 social-media-icons">
                                  <a href="https://www.facebook.com/hardik.chugh.7" target="_blank" rel="noopener noreferrer">
                                     <img src={FacebookIcon} alt="facebook" id="twitter"  />
                                  </a>
                             </div>
                       </div>    
                        </div>
                 
                  </div>
            );
      }
}

export default NavbarOverlayComponent;
